import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick"; // Ensure you have react-slick installed
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import bgImage from "../image/productbanner4.jpg";
import Product from "./Products";
import BaseUrl from './Baseurl/Api.js';

const Productcard = () => {
  const [productDetails, setProductDetails] = useState([]);
  const [productValue, setProductValue] = useState([]);


  useEffect(() => {
    fetch(`${BaseUrl}/api/get_allproduct`) // ✅ use BaseUrl
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setProductDetails(data.product);
        }
      })
      .catch((error) => console.error("Error fetching product data:", error));
  }, []);

  useEffect(() => {
    fetch(`${BaseUrl}/api/get_inventoryData`)  
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setProductValue(data.inventorydata);
        }
      })
      .catch((error) => console.error("Error fetching inventory data:", error));
  }, []);



  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],

  };


  return (
    <>
      {/* Breadcrumb Banner */}
<section
  className="pb-5 position-relative"
  style={{
    background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url('https://images.unsplash.com/photo-1501004318641-b39e6451bec6?q=80&w=1600&auto=format&fit=crop') center/cover no-repeat`,
    minHeight: "300px",
    display: "flex",
    alignItems: "center",
  }}
>
  <div className="container text-white text-center">
   
   

    {/* Title */}
    <h1
      className="fw-bold"
      style={{
        fontSize: "clamp(2rem, 5vw, 3.5rem)",
        letterSpacing: "1.5px",
        textShadow: "2px 2px 8px rgba(0,0,0,0.6)",
      }}
    >
      🌱 Organic Agriculture Products
    </h1>

    {/* Subtitle */}
    <p
      style={{
        fontSize: "1.2rem",
        fontWeight: "300",
        marginTop: "10px",
      }}
    >
      Fresh • Natural • Sustainable
    </p>

    {/* CTA Button triggers modal */}
    <button
      type="button"
      className="btn btn-success btn-lg mt-3 shadow"
      data-bs-toggle="modal"
      data-bs-target="#organicModal"
    >
      Learn More
    </button>
  </div>
</section>

{/* Modal for Organic Info */}
<div
  className="modal fade"
  id="organicModal"
  tabIndex="-1"
  aria-labelledby="organicModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered modal-lg">
    <div className="modal-content rounded-4 shadow">
      <div
        className="modal-header"
        style={{ backgroundColor: "#8ab849", color: "#fff" }}
      >
        <h5 className="modal-title fw-bold" id="organicModalLabel">
          Why Choose Organic?
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body p-4">
        <div className="row align-items-center">
          <div className="col-md-6">
            <img
              src="https://images.unsplash.com/photo-1600431521340-491eca880813?q=80&w=1600&auto=format&fit=crop"
              alt="Organic Farming"
              className="img-fluid rounded-3 shadow-sm"
            />
          </div>
          <div className="col-md-6 mt-3 mt-md-0">
            <h4 className="fw-bold text-success">Pure & Eco-Friendly</h4>
            <p>
              Our organic agriculture products are grown without harmful
              chemicals or pesticides. By choosing organic, you support
              sustainable farming practices and enjoy healthier, fresher
              produce.
            </p>
            <ul>
              <li>🌿 100% Chemical Free</li>
              <li>🍅 Farm Fresh Quality</li>
              <li>🌍 Supports Eco-System</li>
              <li>💚 Healthier Lifestyle</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-outline-success"
          data-bs-dismiss="modal"
        >
          Close
        </button>
        <a href="#carts" className="btn btn-success"  data-bs-dismiss="modal">
          Explore Products
        </a>
      </div>
    </div>
  </div>
</div>


      {/* Background Banner */}

      <div className="container">
        <div className="row">

          {productDetails

            .map((productData) => (
              <div id="carts" key={productData.id} style={{minHeight : "472px"}} className="col-lg-3 col-md-4 col-6 p-3">
                <Link to={`/productdetails/${productData.id}`} style={{ textDecoration: "none" }}>
                  <div className="card rounded-4 p-3 shadow text-center h-100"
                    style={{ transition: "transform 0.3s", cursor: "pointer", }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <img className="img-fluid rounded-4 w-100 h-100 object-fit-cover" src={`https://dharajwebbackend.concentics.com/productimage/${productData.productImage}`}
                      alt={productData.productName}

                      onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/100?text=No+Image")
                      }
                    />
                    <h3 className="product-name mt-3 fs-3 fw-bold"
                      style={{
                               fontFamily: '"Montserrat", sans-serif',
                               fontSize: "1.2rem",
                               lineHeight: "1.4rem",
                               height: "2.8rem", // keeps it to 2 lines
                               overflow: "hidden",
                               textOverflow: "ellipsis",
                               display: "-webkit-box",
                               WebkitLineClamp: 2,  // limits to 2 lines
                               WebkitBoxOrient: "vertical",
                               wordBreak: "break-word",
                             }}
                    >
                      {productData.productName}
                    </h3>



                    {productValue
                      .filter(
                        (productValuesData) =>
                          productValuesData.pid.toString() ===
                          productData.id.toString()
                      )
                      .map((productValuesData) => (
                        <>
                          <p key={productValuesData.id}>
                            {productValuesData.price
                              ? `₹${productValuesData.price}`
                              : "Price Not Available"}
                          </p>
                        </>

                      ))}

                    <div className="row text-center">
  {/* Add to Cart */}
  <div className="button-container col-lg-6 col-md-6 col-12 mb-3">
    <Link
      to={`/productdetails/${productData.id}`}
      style={{ textDecoration: "none" }}
    >
      <button
        className="productbutton w-100 d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "#709a34ff",
          color: "#fff",
          border: "none",
          borderRadius: "30px",
          padding: "10px 15px",
          fontSize: "15px",
          fontWeight: "600",
          fontFamily: "'Poppins', sans-serif",
          transition: "all 0.3s ease-in-out",
          boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#065f46";
          e.currentTarget.style.boxShadow = "0 6px 15px rgba(6,95,70,0.4)";
          e.currentTarget.querySelector("i").style.transform = "translateX(4px)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#709a34ff";
          e.currentTarget.style.boxShadow = "0 3px 6px rgba(0,0,0,0.1)";
          e.currentTarget.querySelector("i").style.transform = "translateX(0)";
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = "scale(0.95)";
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <i className="bi bi-cart3 me-2 fs-5" style={{ transition: "all 0.3s ease" }}></i>
        Add to Cart
      </button>
    </Link>
  </div>

  {/* Buy Now */}
  <div className="button-container col-lg-6 col-md-6 col-12 mb-3">
    <Link
      to="/productdetails"
      style={{ textDecoration: "none" }}
    >
      <button
        className="productbutton1 w-100 d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "transparent",
          color: "#8ab849",
          border: "2px solid #8ab849",
          borderRadius: "30px",
          padding: "8px 5px",
          fontSize: "15px",
          fontWeight: "600",
          fontFamily: "'Poppins', sans-serif",
          transition: "all 0.3s ease-in-out",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#065f46";
          e.currentTarget.style.color = "#fff";
          e.currentTarget.style.borderColor = "#065f46";
          e.currentTarget.style.boxShadow = "0 6px 15px rgba(6,95,70,0.4)";
          e.currentTarget.querySelector("i").style.transform = "rotate(20deg)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.color = "#8ab849";
          e.currentTarget.style.borderColor = "#8ab849";
          e.currentTarget.style.boxShadow = "none";
          e.currentTarget.querySelector("i").style.transform = "rotate(0deg)";
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = "scale(0.95)";
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <i className="bi bi-lightning-charge-fill me-2 fs-5" style={{ transition: "all 0.3s ease" }}></i>
        Buy Now
      </button>
    </Link>
  </div>
</div>


                  </div>
                </Link>
              </div>
            ))}
        </div>
      </div>

      <Product />

    </>
  );
};

export default Productcard;
